import React from 'react';
import { UnsubscribedPaymentHeader } from './UnsubscribedPaymentHeader';
import { UnsubscribedSubscriptionPlan } from './UnsubscribedSubscriptionPlan';
export const UnSubscribedUserSubscriptionPaymentWrapper=({openPaymentPortal,reActiveConfirmation,getHostPage,openPaymentModal,handleCancel,handleOk})=>{
    return (
        <div>
       <UnsubscribedPaymentHeader/>
       <UnsubscribedSubscriptionPlan
       openPaymentPortal={openPaymentPortal}
       reActiveConfirmation={reActiveConfirmation}
       getHostPage={getHostPage}
       handleOk={handleOk}
       handleCancel={handleCancel}
       openPaymentModal={openPaymentModal}
       />
    </div>
    )
}